// permissionUtils.ts
type PermissionAction = 'view' | 'create' | 'update' | 'delete';

export const checkPermission = (
  permissions: any,
  module: string,
  action: PermissionAction
): boolean => {
  return permissions?.[module]?.[action] ?? false;
};

/** Super Admin (role 1) only. API still enforces Super Admin on tax endpoints. */
export const canAccessTaxReport = (
  permissions: any,
  roleID: number | undefined
): boolean => {
  if (roleID !== 1) return false;
  if (permissions?.taxReport == null) return true;
  return checkPermission(permissions, 'taxReport', 'view');
};
